module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-cta-modal"
  }, [_c('div', {
    staticClass: "block-cta-modal__bg"
  }, [_c('div', {
    staticClass: "block-cta-modal__container"
  }, [_c('div', {
    staticClass: "block-cta-modal__body"
  }, [_c('div', {
    staticClass: "block-cta-modal__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.text)
    }
  }), (_vm.props.add_openchair) ? _c('div', {
    staticClass: "block-cta-modal__button",
    class: 'openchair-widget',
    attrs: {
      "tabindex": "0",
      "aria-label": _vm.props.aria ? _vm.props.aria : null
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.onClick
    }
  }) : (!_vm.alt) ? _c('div', {
    staticClass: "block-cta-modal__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.activate
    }
  }) : (_vm.alt) ? _c('div', {
    staticClass: "block-cta-modal__button",
    domProps: {
      "innerHTML": _vm._s(_vm.props.button)
    },
    on: {
      "click": _vm.toggleModal
    }
  }) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79b23e9b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-cta-modal/block-cta-modal.pug
// module id = 597
// module chunks = 1